import type { ru } from './ru'

export const en: Record<keyof typeof ru, string> = {
  'app.name': 'Brain Hone',

  'nav.today': 'Today',
  'nav.games': 'Games',
  'nav.progress': 'Progress',

  'onboarding.hello': 'Welcome',
  'onboarding.helloName': 'Hi, {name}',
  'onboarding.p1.title': 'Four exercises a day',
  'onboarding.p1.text': 'Two for memory, two for attention. About six minutes.',
  'onboarding.p2.title': 'Difficulty adapts',
  'onboarding.p2.text': 'Level and pace follow you - both accuracy and speed.',
  'onboarding.p3.title': 'Your score sharpens over days',
  'onboarding.p3.text': 'The first estimate is rough. After five sessions you get an exact Hone Score - measured against you, not against others.',
  'onboarding.start': 'Start your first workout',
  'home.morning': 'Good morning',
  'home.day': 'Good afternoon',
  'home.evening': 'Good evening',
  'home.workout': 'Daily workout',
  'home.continue': 'Continue',
  'home.left': '{n} left',

  'insight.title': 'What this session showed',
  'insight.accurateSlow.title': 'Accurate, but unhurried',
  'insight.accurateSlow.advice': 'Try answering slightly before you feel certain. Difficulty will rise and the session will do more for you.',
  'insight.fastSloppy.title': 'Fast, but error-prone',
  'insight.fastSloppy.advice': 'Speed does not pay here: an error costs more than the second you saved. Give yourself half a second to check.',
  'insight.climbed.title': 'Level rose in {n} exercises',
  'insight.climbed.advice': 'The task adapted to you. Accuracy usually dips on a new level - that is expected.',
  'insight.dropped.title': 'Level went down',
  'insight.dropped.advice': 'That is the system working: it looks for a level you can handle. If it repeats for several days, try training at a different time of day.',
  'insight.gap.title': 'Gap between disciplines',
  'insight.gap.advice': "Tomorrow's programme will start with the weaker one.",
  'insight.steady.title': 'Steady session',
  'insight.steady.advice': 'Your numbers are stable. Regularity matters more than intensity here - a short daily session beats a long weekly one.',
  'insight.building.title': 'Still calibrating',
  'insight.building.advice': 'For the first few sessions the app is finding a level and pace that fit you. It gets more comfortable.',
  'index.title': 'Hone Score',
  'index.provisional': 'Provisional · {n} more sessions for an exact score',
  'index.collectingHint': '{n} more sessions until your index appears',
  'index.weekChange': '{n} this week',

  'discipline.memory': 'Memory',
  'discipline.attention': 'Attention',
  'discipline.perception': 'Perception',

  'game.memoryMatrix': 'Memory Matrix',
  'game.memoryMatrix.hint': 'Memorise the highlighted cells',
  'game.memoryMatrix.recall': 'Mark the cells that were lit ({n})',
  'game.memoryMatrix.review': 'Green is correct, dashed is missed',
  'game.missingOne': 'Missing One',
  'game.missingOne.hint': 'Which shape is missing?',
  'game.missingOne.study': 'Memorise the shapes',
  'game.snowflake': 'Snowflake',
  'game.snowflake.hint': 'Which arm fits the empty sector?',
  'game.stroop': 'Stroop',
  'game.stroop.hint': 'Tap the colour the word is written in',
  'game.reactionTarget': 'Reaction Target',
  'game.reactionTarget.hint': 'Find the arrow pointing differently',

  'color.red': 'red',
  'color.blue': 'blue',
  'color.green': 'green',
  'color.yellow': 'yellow',
  'color.purple': 'purple',
  'color.orange': 'orange',
  'color.teal': 'teal',
  'color.pink': 'pink',
  'game.level': 'Level {n}',
  'game.done': 'Done',

  'result.accuracy': 'Accuracy',
  'result.again': 'Again',
  'result.sessionDone': 'Session complete',
  'result.points': 'points',
  'result.span': 'Span',

  'today.sub': "Today's programme is ready",
  'today.weak': 'Working on {d} today - those come first',
  'today.start': 'Start workout',
  'today.doneTitle': 'Workout complete',
  'today.empty': 'Done for today. Come back tomorrow',
  'workout.next': 'Next exercise',
  'workout.finish': 'Finish workout',
  'games.sub': 'Any exercise, any time',
  'progress.week': 'Last 7 days',
  'day.mon': 'Mon',
  'day.tue': 'Tue',
  'day.wed': 'Wed',
  'day.thu': 'Thu',
  'day.fri': 'Fri',
  'day.sat': 'Sat',
  'day.sun': 'Sun',
  'progress.sub': 'Measured against your own baseline',
  'progress.sessions': 'Sessions total',
  'progress.bestSpan': 'best span',
  'progress.sessionsShort': 'sessions',
  'progress.collecting': '{n} more sessions until your first score',
  'progress.noData': 'Play a few rounds and your trend shows up here',
  'result.finish': 'Finish',
  'reminder.title': 'Reminders',
  'reminder.daily': 'Once a day',
  'reminder.time': 'At',
  'reminder.hint': "We'll nudge you if the day's workout is still undone",
  'reminder.denied': 'The bot needs permission to message you, otherwise the reminder cannot arrive',
  'settings.theme': 'Theme',
  'settings.theme.auto': 'Auto',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.language': 'Language',

  'common.streak': '{n} days',
}
